import React, { useEffect, useState } from 'react';

const SearchFilter = ({ show, options, onClose, gender, language, clinicalInterest }) => {
    if (show) {
        document.body.style.paddingRight = "-1";
    } else {
        document.body.style.paddingRight = "0";
    }

    function clearAll() {
        let cb = document.getElementsByClassName("form-check-input");
        for (let i = 0; i < cb.length; i++) {
            (cb[i] as HTMLInputElement).checked = false;
        }
    }

    function buildCheckBoxList(name: string, options: any[], checked: any[]) {
        return options.map((o, i) =>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" id={name + i} value={o.value} defaultChecked={checked.indexOf(o.value) >= 0} />
                <label className="form-check-label" htmlFor={name + i}>{o.name}</label>
            </div>
        )
    }

    return (<>
        <div className="modal" tabIndex={-1} aria-labelledby="moreFiltersLabel" aria-hidden="true" style={{ display: show ? "block" : "none" }}>
            <div className="modal-dialog">
                <div className="modal-content" style={{ maxHeight: "98vh", overflowY: "auto" }}>
                    <div className="modal-header">
                        <h5 className="modal-title" id="moreFiltersLabel">Select Filters</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose} >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row d-flex">
                            <div className="col">
                                <fieldset className="mb-3" id="filterGender">
                                    <legend>Gender of Provider</legend>
                                    {buildCheckBoxList("gender", options.gender, gender || [])}
                                </fieldset>

                                <fieldset className="mb-3" id="filterClinicalInterest">
                                    <legend>Additional Clinical Interest</legend>
                                    {buildCheckBoxList("clinterest", options.clinicalInterest, clinicalInterest || [])}
                                </fieldset>
                            </div>
                            <div className="col">
                                <fieldset className="mb-3" id="filterLanguage">
                                    <legend>Languages Spoken</legend>
                                    {buildCheckBoxList("language", options.language, language || [])}
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-primary" onClick={clearAll}>Clear</button>
                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={onClose}>Done</button>
                    </div>
                </div>
            </div>
        </div>
        {show && <div className={"modal-backdrop fade show"}></div>}
    </>
    );
}

export default SearchFilter;